export default __webpack_public_path__ + "static/media/clinic_history.a3cb8ff4.png";